"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseZmodPinPostLink = parseZmodPinPostLink;
/** `act=zmod|mod` + `CODE=update-pinned` — поднять пост в шапку темы (Android o1.java). */
function parseZmodPinPostLink(params) {
    const act = (params.get('act') || '').toLowerCase();
    if (act !== 'zmod' && act !== 'mod')
        return null;
    const code = (params.get('code') || params.get('CODE') || '').toLowerCase();
    if (code !== 'update-pinned')
        return null;
    const postId = parseInt(params.get('p') || '', 10);
    if (!Number.isFinite(postId) || postId <= 0)
        return null;
    const topicId = parseInt(params.get('t') || '', 10);
    const offset = parseInt(params.get('st') || '0', 10);
    return {
        topicId: Number.isFinite(topicId) && topicId > 0 ? topicId : 0,
        postId,
        offset: Number.isFinite(offset) && offset >= 0 ? offset : 0,
    };
}
